import constants from "../../config/constants";

const $inject = ['$location', 'dataService', 'settingsService', 'microApiService', 'dataSourceService'];

const lbaAddGridResourceCtrl = function ($location, dataService, settingsService, microApiService, dataSourceService) {
  const vm = this;

  vm.fields = settingsService.settings.fields;
  vm.formErrors = false;
  dataService.data.activeItem = angular.copy(vm.settings.data);
  vm.data = dataService.data.activeItem;
  vm.indexArray = '';
  vm.waiting = false;
  vm.success = false;
  vm.cancel = cancel;
  vm.add = add;

  if (vm.settings.microService) {
    dataSourceService.dataSource = constants.DATA_SOURCES.AUTH_ZERO;
  }

  function cancel() {
    $location.path($location.$$path.slice(0, -3));
  }

  function processPostResponse(res) {
    const locationPathTrimmed = $location.$$path.slice(0, -3);
    vm.waiting = false;
    vm.success = true;
    dataService.data.activeItem = undefined;
    $location.path(locationPathTrimmed + res.data.Id);
  }

  function add() {
    if (!vm.addGridResourceForm.$valid) {
      vm.formErrors = true;

      return false;
    }

    vm.waiting = true;

    if (vm.settings.microService) {
      microApiService.post({
        endpoint: `${vm.settings.endpoint}`,
        data: dataService.data.activeItem,
        cb: processPostResponse
      })
    } else {
      dataService.post(vm.settings.endpoint, vm.data).then(data => {
        vm.waiting = false;
        vm.success = true;

        const locationPathTrimmed = $location.$$path.slice(0, -3);
        dataService.data.activeItem = undefined;
        $location.path(locationPathTrimmed + data.Id);
      });
    }
  }
};

lbaAddGridResourceCtrl.$inject = $inject;

export default lbaAddGridResourceCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaAddGridResource/lbaAddGridResourceCtrl.js